export default __webpack_public_path__ + "static/media/veqtor_edificios.3d442d0d.svg";